import { Field } from 'react-final-form';
import { required } from '../../../helpers';
import FormError from '../../Common/FormError';

const PaydayLoanForm = () => {
  return (
    <>
      <div className='mb-5 col-lg-12'>
        <label className='form-label mb-3'>Loan Title</label>
        <Field name='project_name' type='text' validate={(v) => required(v, 'Loan title')}>
          {({ input, meta }) => (
            <>
              <div className='mb-3'>
                <input type='text' {...input} className='form-control form-control-lg form-control-solid' />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>
      <div className='mb-5 col-lg-12'>
        <label className='form-label mb-3'>Loan Amount</label>
        <Field name='loan_amount' type='number' validate={(v) => required(v, 'Loan amount')}>
          {({ input, meta }) => (
            <>
              <div className='mb-3'>
                <input type='number' {...input} className='form-control form-control-lg form-control-solid' />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>

      <div className='mb-5 col-lg-12'>
        <label className='form-label mb-3'>Loan Tenure</label>
        <Field name='loan_tenure' type='number' validate={(v) => required(v, 'Loan tenure')}>
          {({ input, meta }) => (
            <>
              <div className='mb-3'>
                <input type='number' placeholder='in months' {...input} className='form-control form-control-lg form-control-solid' />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>
    </>
  );
};

export default PaydayLoanForm;
